import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';

import { completeName } from 'helpers/name';

const displayName = (name, isFirefox) => (
  <Dotdotdot clamp={isFirefox ? 2 : 1} useNativeClamp>
    {name}
  </Dotdotdot>
);

const DisplayUserName = ({ user, isFirefox, showCompleteName = false }) =>
  showCompleteName ? (
    <span className="block soft-half--top color-black break-all">
      {displayName(completeName(user), isFirefox)}
    </span>
  ) : (
    <>
      <span className="block soft-half--top color-black break-all">
        {displayName(user.firstname, isFirefox)}
      </span>
      <span className="block color-black break-all">
        {displayName(user.lastname, isFirefox)}
      </span>
    </>
  );

DisplayUserName.propTypes = {
  user: PropTypes.object.isRequired,
  isFirefox: PropTypes.bool,
  showCompleteName: PropTypes.bool,
};

export default DisplayUserName;
